import React, { useCallback, useContext, useEffect, useState } from "react";

import { Container } from './styles';

/* Assets */
import { FaCaretRight, FaCaretLeft } from "react-icons/fa";

/* Contexts */

import {GameContext} from "../../context/GameContext";

export const Clues: React.FC = () => {
  const {
    state: {GameState, GameTemplate},
    dispatch,
  } = useContext(GameContext); 

  const handleArrowPressNext = () => {
    dispatch({type: 'NEXT_CLUE'});
  };
  const handleArrowPressPrevious = () => {
    dispatch({type: 'PREVIOUS_CLUE'});
  };

  return (
      <Container>
        <div className="caretIcon" onClick={handleArrowPressPrevious}>
          <FaCaretLeft size="35"/>
        </div>
       <h2 className="currentClueText">
         {GameState.currentClueText}
       </h2>
       <div className="caretIcon" onClick={handleArrowPressNext}>
          <FaCaretRight size="35"/>
        </div>
      </Container>

  )
}